import { render, staticRenderFns } from "./UserSignature.vue?vue&type=template&id=ff143e46&"
import script from "./UserSignature.vue?vue&type=script&lang=js&"
export * from "./UserSignature.vue?vue&type=script&lang=js&"
import style0 from "./UserSignature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports